function shouldDiscountProduct(productId, fullPricedCollection) {
  for (const element of fullPricedCollection) {
    if (element["id"] == productId) {
      return true;
    }
  }

  return false;
}

function getDiscountFromCookie() {
  const getCookieValue = (name) =>
    document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")?.pop() || "";

  const discountCode = getCookieValue("discount_code");

  if (discountCode == null || discountCode == 0) {
    return 0;
  }

  var percentToReturn = 0;

  jQuery.ajax({
    url: "https://nira-shopify-bucket.s3.amazonaws.com/discount_codes.json",
    dataType: "json",
    success: function (data) {
      if (data[discountCode] > 0) {
        percentToReturn = data[discountCode];
      }
    },
    async: false,
  });

  return percentToReturn;
}

function getStrikeThroughPriceFor(currentVariantPrice, productId) {
  var percentOff = getDiscountFromCookie();
  
  const getCookieValue = (name) => document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")?.pop() || "";
  const discountCode = getCookieValue("discount_code");

  if (discountCode == 'BDAY20' && currentVariantPrice > 54900) {
    return null;
  }

  if (percentOff == null || percentOff == 0) {
    return null;
  }

  var price = currentVariantPrice * ((100 - percentOff) / 100);
  var priceAsDollars = (price / 100).toFixed(2);

  var originalPrice = currentVariantPrice;
  var originalPriceAsDollars = (originalPrice / 100).toFixed(2);

  return (
    "<s>$" +
    originalPriceAsDollars.toString() +
    "</s> $" +
    priceAsDollars.toString()
  );
}

function getDiscountedPriceFor(currentVariantPrice, productId) {
  var percentOff = getDiscountFromCookie();

  if (percentOff == null || percentOff == 0) {
    return null;
  }

  var price = currentVariantPrice * ((100 - percentOff) / 100);
  return (price / 100).toFixed(2);
}

document.addEventListener("DOMContentLoaded", function (event) {
  function checkJQuery() {
    if (window.jQuery) {
      $(window).trigger("resize.twentytwenty");

      const twentyTwentyContainerElements = document.getElementsByClassName(
        "twentytwenty-container"
      );
      if (twentyTwentyContainerElements.length) {
        const overlay =
          twentyTwentyContainerElements[0].dataset.overlay ?? false;
        $(".twentytwenty-container").twentytwenty({
          default_offset_pct: 0.7, // How much of the before image is visible when the page loads
          //  orientation: 'vertical', // Orientation of the before and after images ('horizontal' or 'vertical')
          before_label: "", // Set a custom before label
          after_label: "", // Set a custom after label
          no_overlay: overlay, //Do not show the overlay with before and after
          //  move_slider_on_hover: true, // Move slider on mouse hover?
          move_with_handle_only: true, // Allow a user to swipe anywhere on the image to control slider movement.
          click_to_move: false, // Allow a user to click (or tap) anywhere on the image to move the slider to that location.
        });
      }
    } else {
      window.setTimeout("checkJQuery();", 100);
    }
  }

  checkJQuery();
});

$(document).ready(function () {
  $(".trigger-klarna-popup").click(function (e) {
    console.log("KLARNA");
    $(".popup-klarna").show();
  });

  $(".klarna__close-icon").click(function (e) {
    $(".popup-klarna").hide(); // Now the pop up is hidden.
  });
});

$(document).ready(function () {
  $(".delay-popup").click(function (e) {
    $(".popup-delay").show();
  });

  $(".klarna__close-icon").click(function (e) {
    $(".popup-delay").hide(); // Now the pop up is hidden.
  });
});

// BEFORE & AFTER SLIDER
$(document).ready(function () {
  $(".faq-question").on("click", function () {
    const next_sibling = $(this).next();
    $(".faq-answer").not(next_sibling).stop().slideUp();
    $(".faq-question").not(this).removeClass("active");
    $(this).toggleClass("active").next().stop().slideToggle();
  });

  $("#after").css("display", "none");
  $("#before").css("display", "none");

  var scrollBottom = $(window).scrollTop() + $(window).height();
  if (
    $(".ba-home").offset() &&
    scrollBottom > $(".ba-home").offset().top - 500
  ) {
    $("#after").css("display", "block");
    $("#before").css("display", "block");
  }

  var before = $("#before");
  $(".thumbs li").click(function (e) {
    var data = this.onclick(),
      after = $("#after")[0],
      before = $("#before")[0];
    $(".thumbs li.active").removeClass("active");
    this.className = "active";

    after.style.backgroundImage = "none";
    before.style.backgroundImage = "none";
    after.style.backgroundImage = "url(" + data.after + ")";
    before.style.backgroundImage = "url(" + data.before + ")";
  });

  $("#control").draggable({
    axis: "x",
    containment: "parent",
    drag: function (e, ui) {
      $("#before").css("width", ui.position.left + 34 + "px");
    },
  });

  $("#control").on("mousedown", function () {
    //$(this).addClass('used');
  });

  $("#before").css("width", $("#sContainer").width() - 70);

  $("#before").css("min-height", $("#sContainer").width() * 0.93);
  $("#after").css("min-height", $("#sContainer").width() * 0.93);
  $("#slideInner").css("min-height", $("#sContainer").width() * 0.93);

  $("#control").css("left", $("#before").width() - 34 + "px");
  $("#control .line").css("height", $("#sContainer").width() + "px");
  let thumbsLi = $(".thumbs li")[0];
  if (thumbsLi != null) thumbsLi.click();
});

$(window).scroll(function () {
  var scrollBottom = $(window).scrollTop() + $(window).height();
  if (
    $("#after").css("display") == "none" &&
    scrollBottom > $(".ba-home").offset().top - 500
  ) {
    $("#after").css("display", "block");
    $("#before").css("display", "block");
  }
});

$(window).load(function () {
  var boldLink = document.querySelector(".bold-ro__detail-tooltip");
  if (boldLink) {
    boldLink.classList.add("no-transition");
  }
});

$(window).load(function () {
  var multiWrapper = document.querySelector(".multi-ba-wrapper");

  if (multiWrapper && window.location.href.indexOf("products") > -1) {
    document.head.insertAdjacentHTML(
      "beforeend",
      `<style>
			@media only screen and  (min-width: 768px) {
              .multi-ba-wrapper {
                  display: none;
              }
			}</style>`
    );
  }
});

$(window).load(function () {
  $(".header").removeClass("is-loading");
  $(".page-transition").removeClass("is-loading");
});

$(window).load(function () {
  var stampedWrite = $(".stamped-proxy-write");

  if (!stampedWrite.get(0)) {
    return;
  }

  var h1 = document.createElement("h1");
  h1.innerHTML = "Write a Review and Share Your NIRA Skincare Experience";
  h1.style = "display: none;";
  document.getElementsByTagName("body")[0].prepend(h1);

  document.querySelector('meta[name="description"]').remove();
  document.querySelector("title").remove();

  var meta = document.createElement("meta");
  meta.name = "description";
  meta.content =
    "Have you tried the NIRA Anti-Aging Skincare Laser? Write an honest review and let us know how NIRA has helped you!";
  document.getElementsByTagName("head")[0].appendChild(meta);

  var title = document.createElement("title");
  title.innerHTML = "Write a Review on the NIRA Anti-Aging Skincare Laser.";
  document.getElementsByTagName("head")[0].appendChild(title);
});

$("form").submit(function (event) {
  if (this.getAttribute("action") != "/cart/add") {
    return;
  }

  $("#quick-cart-free-shipping").removeClass("quick-cart-shipping-hidden");
  $("#quick-cart-free-shipping").addClass("quick-cart-shipping");
});

$(window).load(function () {
  var boldRadioSubscribeButton = document.querySelector(
    ".bold-ro__subscribe-radio-btn"
  );
  var boldRadioOneTimeButton = document.querySelector(
    ".bold-ro__one-time-radio-btn"
  );

  if (boldRadioSubscribeButton) {
    boldRadioSubscribeButton.addEventListener("click", function () {
      document.querySelector(".addtocart").classList.add("bold-hide-cart");
      document.querySelector(".subscribe-now-button").style.display = "block";
    });
  }

  if (boldRadioOneTimeButton) {
    boldRadioOneTimeButton.addEventListener("click", function () {
      document.querySelector(".addtocart").classList.remove("bold-hide-cart");
      document.querySelector(".subscribe-now-button").style.display = "none";
    });
  }
});

$(document).ready(function () {
  if (window.location.href.indexOf("pages/nira-temp-instructions") > -1) {
    document.querySelector(".shogun-image-link").style.border = "none";
    document.querySelector(".shogun-tabs-body").style.border = "none";

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const platform = urlParams.get("platform");

    const tabsContainer = document.querySelector(".shogun-tabs");
    const tabBodyContainer = document.querySelector(".shogun-tabs-body");

    tabsContainer.style.display = "none";

    if (platform == "iOS") {
      tabBodyContainer.children[0].classList.add("shogun-tab-active");
      tabBodyContainer.children[1].classList.remove("shogun-tab-active");
    } else {
      tabBodyContainer.children[0].classList.remove("shogun-tab-active");
      tabBodyContainer.children[1].classList.add("shogun-tab-active");
    }
  }
});

$(document).ready(function () {
  if (
    window.location.href.indexOf("pages/nira-temp-choose-ios-or-android") > -1
  ) {
    const os = getMobileOperatingSystem();

    if (os == "Android") {
      window.location.replace(
        "https://www.niraskin.com/pages/nira-temp-instructions?platform=Android"
      );
    } else if (os == "iOS") {
      window.location.replace(
        "https://www.niraskin.com/pages/nira-temp-instructions?platform=iOS"
      );
    }
  }

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  }
});

$(document).ready(function () {
  $("#price-test-add-to-cart").click(function () {
    gtag("event", "add_to_cart", {
      url: window.location.href,
    });

    var value = $(".current_price_span").html().replace("$", "");
    var floatValue = parseFloat(value);

    fbq("track", "AddToCart", {
      value: floatValue,
    });
  });
  let content = "";
  let ul_content = "";
  $(".faqs-container .faqs-block-title").each(function () {
    const faq_sub_heading = $(this).attr("id");
    const faq_text = $(this).text().split(" ")[0];
    ul_content += `<li data-faq-title="${faq_sub_heading}">${faq_text}</li>`;
  });
  $(".product__tab-wrapper .product__tab").each(function () {
    const faq_title = $(this).data("sidebar-title");
    const faq_link = $(this).data("page-handle");
    const has_active_class = $(this).hasClass("active") || "";
    let active_class_data = "";
    if (has_active_class) {
      active_class_data = `<div class="sidebar-block ${
        has_active_class ? "active" : ""
      }">
        <p>${faq_title}</p>
        <ul>${ul_content}</ul>
      </div>`;
    } else {
      active_class_data = `<div class="sidebar-block"><a href="/pages/${faq_link}">${faq_title}</a></div>`;
    }
    content += active_class_data;
  });
  $(".faqs-sidebar .sidebar-blocks").html(content);
});
